// extracted by mini-css-extract-plugin
export var headerInner = "contribution-module--headerInner--qjRuF";